import * as React from 'react';

import { Box } from '@mui/joy';
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import Typography from '@mui/joy/Typography';

interface GeneralModalProps {
  open: boolean;
  title: string;
  content: React.ReactNode;
  actions: React.ReactNode;
  onClose: () => void;
}

const GeneralModal: React.FC<GeneralModalProps> = ({ open, title, content, actions, onClose }) => (
  <Modal onClose={onClose} open={open}>
    <ModalDialog
      aria-describedby='general-modal-description'
      aria-labelledby='general-modal-title'
      sx={{ maxWidth: 600 }}
    >
      <ModalClose onClick={onClose} sx={{ m: 1 }} variant='plain' />
      <Typography id='general-modal-title' level='h2'>
        {title}
      </Typography>
      <Box sx={{ mt: 2 }}>{content}</Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>{actions}</Box>
    </ModalDialog>
  </Modal>
);

export default GeneralModal;
